import React from 'react'
import SingleCard from './SingleCard'
import { BaseComponentProps, CardType } from './Ui'
import { styled } from '@mui/material'
import { ElementContainer } from './Ui'

const SixCardGridWrapper = styled('div')<BaseComponentProps>(
  ({ theme, spacingBottomDesktop, spacingBottomMobile }) => ({
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'stretch',
    marginBottom: spacingBottomMobile,
    [theme.breakpoints.up('md')]: {
      marginBottom: spacingBottomDesktop
    },
    '& .mui-card': {
      '&:last-child': {
        marginBottom: 0
      },
      [theme.breakpoints.between('sm', 'lg')]: {
        width: 'calc(50% - 16px)',
        '&:nth-of-type(odd)': {
          marginRight: '16px'
        },
        '&:nth-of-type(n+5)': {
          marginBottom: 0
        }
      },
      [theme.breakpoints.up('lg')]: {
        maxWidth: 'calc(33.333% - 16px)',
        marginRight: '24px',
        '&:nth-of-type(3n)': {
          marginRight: 0
        },
        '&:nth-of-type(n+4)': {
          marginBottom: 0
        }
      }
    }
  })
)

interface SixCardGridProps extends BaseComponentProps {
  card1: CardType
  card2: CardType
  card3: CardType
  card4: CardType
  card5: CardType
  card6: CardType
}

const SixCardGrid: React.FC<SixCardGridProps> = ({
  card1,
  card2,
  card3,
  card4,
  card5,
  card6,
  spacingBottomDesktop,
  spacingBottomMobile
}) => {
  const cards = [card1, card2, card3, card4, card5, card6]
  return (
    <ElementContainer>
      <SixCardGridWrapper
        spacingBottomDesktop={spacingBottomDesktop}
        spacingBottomMobile={spacingBottomMobile}
        data-testid="six-card-grid-wrapper"
      >
        {cards.map((card, index) => (
          <SingleCard key={index} card={card} />
        ))}
      </SixCardGridWrapper>
    </ElementContainer>
  )
}

export default SixCardGrid
